import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Card, Flex, Spinner, Title } from '../../../../components';
import { useGetAttractionsFromFirestore, useQueryHelper } from '../../../../queries';
import { useHotelState, useLanguageState } from '../../../../state';
import { AttractionsFirestoreResponse, AttractionType } from '../../../../types';
import { getIcon, getTitle } from './utils';

interface AttractionBlockProps {
  filterKey: string[];
  type: AttractionType;
}

export const AttractionBlock: FC<AttractionBlockProps> = ({
  filterKey,
  type,
}) => {
  const { t } = useTranslation();
  const attractions = useGetAttractionsFromFirestore(filterKey, type);
  const { hotelData } = useHotelState();
  const navigate = useNavigate();
  const { data: attractionData } = attractions;
  const { language: currentLang } = useLanguageState();

  const { isLoading } = useQueryHelper({
    queries: [
      attractions,
    ],
  });

  return (
    <Fragment key="attraction-culture">
      {attractionData && attractionData?.length > 0 && (
        <Flex direction="column" flexWrap="nowrap" margin="10px 0">
          <Title icon={getIcon(type)} title={getTitle(t, type)} />
          {isLoading ? <Spinner /> : (
            <Swiper
              spaceBetween={5}
              style={{ width: '100%' }}
              slidesPerView={1.2}
              lazy="true"
              loop
              centeredSlides
              breakpoints={{
                768: {
                  slidesPerView: 2.2,
                  centeredSlides: true,
                },
                1024: {
                  slidesPerView: 3.4,
                  centeredSlides: true,
                },
              }}
            >
              {attractionData?.map((item: AttractionsFirestoreResponse) => (
                <SwiperSlide
                  key={item.id}
                >
                  <Card
                    hotelGeopoint={hotelData.address.geoPoint}
                    attractionGeopoint={item.localization}
                    key={item.title[currentLang]}
                    image={item.cover_photo}
                    title={item.title[currentLang]}
                    action={() => navigate(`/attraction/${item?.id}`)}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </Flex>
      )}
    </Fragment>
  );
};
